export default "__VITE_ASSET__Cror6yoy__"